import usePresentSelector from './usePresentSelector';
import G from './Getters';
import Barplot from './Barplot';
import { useStore } from 'react-redux';

export default function QuantifcationResults({annotationId,annotationIds=[]}){

  let store = useStore();
  let state = store.getState();

  let atnIdList = [annotationId,...annotationIds].filter(x => x);

  let quantificationList = atnIdList.map(_id => G.getAnnotationQuantification(state,{_id}));


  //let quantification = usePresentSelector(state => G.getAnnotationQuantification(state,{_id:annotationId}));

  let content;

  if( quantificationList.length === 0 || quantificationList.some(x => !x)){

    content = (
      <div 
        annotationId={annotationId}
        info={"quantificationStatus"}
        quantificationStatus={"unquantified"}
        style={{
          width:'100%',
          height:'100%',
          alignText:'center', 
          display:'flex', 
          justifyContent:'center',
          alignItems:'center',
        }}>
        Quantify to plot results!
      </div>
    )

  }else{


    let type = quantificationList.length === 1 ? null : "points";

    let roundedIntegrations = quantificationList.map( list => list.map(lane => {
      return Math.round(lane.value);
    }));


    //let vals = quantification.map(x => x.value)
    //let fakeVals = quantification.map(x => x.value * Math.random() * 0.5)
    content = (
      <Barplot values={roundedIntegrations} labels={roundedIntegrations[0]}
          type={type}
          outerProps={{
            info:"quantificationStatus",
            annotationId,
            quantificationStatus:"quantified"
          }}
        />
    )

  }


  return content;
}
